export { default } from './SectionTitle'
